(function () {
  function initFaqTabs(root) {
    var sections = root.querySelectorAll('.section-faq:not([data-tabs-initialized])');
    sections.forEach(function (section) {
      var tabs = section.querySelectorAll('.section-faq__tab');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.dataset.tabTarget;

          tabs.forEach(function (t) {
            t.classList.toggle('is-active', t === tab);
          });

          section.querySelectorAll('.section-faq__panel').forEach(function (panel) {
            panel.classList.toggle('is-active', panel.dataset.tabPanel === target);
          });
        });
      });
      section.dataset.tabsInitialized = 'true';
    });
  }

  function initFaq(root) {
    root = root || document;
    initFaqTabs(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFaq(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initFaq(event.target);
  });
})();
